import React from 'react';
import {Upload} from 'components/forms/sections';
import {Route} from 'react-router-dom';
import TOAR from 'components/forms/toar/TOAR';
import ProgressForm from 'components/forms/ProgressForm';
import {FormNames, FormTypes} from '../../../constants';
import {StatePrompt} from 'components/forms';

const FormTOAR = () => {
    const node = FormTypes.TOAR.toLowerCase();

    return (
        <ProgressForm title={FormNames.TOAR} node={node}>
            <StatePrompt />
            <Route path={`/forms/${node}/upload`}>
                <Upload documentType={'nvic'} />
            </Route>
            <Route path={`/forms/${node}/toar`}>
                <TOAR documentType={node} />
            </Route>
        </ProgressForm>
    );
};

export default FormTOAR;
